import { render, staticRenderFns } from "./GoodDetail.vue?vue&type=template&id=4ddb132a&scoped=true&"
import script from "./GoodDetail.vue?vue&type=script&lang=ts&"
export * from "./GoodDetail.vue?vue&type=script&lang=ts&"
import style0 from "./GoodDetail.vue?vue&type=style&index=0&id=4ddb132a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddb132a",
  null
  
)

export default component.exports